import type { IconData } from '@stacksjs/iconify-core'

export const otherUiBinoculars: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.5 0A3.5 3.5 0 0 0 1 3.5v9a3.5 3.5 0 1 0 7 0a3.5 3.5 0 1 0 7 0v-9a3.5 3.5 0 1 0-7 0A3.5 3.5 0 0 0 4.5 0m8.25 12.5a1.25 1.25 0 1 1-2.5 0a1.25 1.25 0 0 1 2.5 0M4.5 13.752a1.25 1.25 0 1 0 0-2.501a1.25 1.25 0 0 0 0 2.501\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default otherUiBinoculars
